import React from "react";
import Container from "../../../../components/Container/index";
import Content from "../../../../components/Content";
import Flex from "../../../../components/Flex";
import Layout from "../../../../components/Layout";
import Spinner from "../../../../components/Loader/Spinner";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const MockSurvivorship = () => {
  const params = useParams();
  const [mockAggregate, setMockAggregate] = useState("");
  const [primaryAddress, setPrimaryAddress] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [isError, setIsError] = useState(false);
  const [metaCorrelation, setMetaCorrelation] = useState("");

  const [showRestrictedDialog, setshowRestrictedDialog] = React.useState(false);
  const [RestrictedEids, setRestrictedEids] = React.useState([]);
  const [isRestricted, setisRestricted] = React.useState(false);

  useEffect(() => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/dynamicsurvivorship/recomputeaggregate/${params.id}`;
    fetch(url, {
      method: "GET",
      headers: {
        clientId: params.clientId,
        "Content-Type": "application/json",
        model: null
      }
    })
      .then(response => {
        let isrestricted = response.isRestricted == "true" ? true : false;
        let restrictedeids = response.RestrictedEids;
        if (
          isrestricted &&
          restrictedeids != "null" &&
          restrictedeids.length > 0
        ) {
          restrictedeids = restrictedeids.replaceAll("Patient/", "");
          setisRestricted(true);
          setRestrictedEids(restrictedeids);
          setshowRestrictedDialog(true);
        }
        return response.json();
      })
      .then(data => {
        if (data.data == null) {
          setIsError(true);
          if (data.metaData && data.metaData.hasOwnProperty("correlationId"))
            setMetaCorrelation(data.metaData.correlationId);
          setIsLoading(false);
          setHasLoaded(true);
          return;
        }
        setMockAggregate(JSON.stringify(data.data, null, 2));
        const perprimerresExtUrl =
          "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#attrCode";
        const perprimerresExtValueString = "PERPRIMERRES";
        if (data.data && data.data.hasOwnProperty("address")) {
          data.data["address"].forEach(addr =>
            addr["extension"].forEach(ext => {
              if (
                ext["url"] == perprimerresExtUrl &&
                ext["valueString"] == perprimerresExtValueString
              ) {
                setPrimaryAddress(JSON.stringify(addr, null, 2));
              }
            })
          );
        }
        setBirthDate(JSON.stringify(data.data["birthDate"], null, 2));
        setIsLoading(false);
        setHasLoaded(true);
      })
      .catch(e => {
        console.log("error:" + e);
      });
  }, [params]);

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>
            <Content>
              <div style={{ width: "100%" }}>
                <div style={{ width: "50%", float: "left" }}>
                  <h1>Dynamic Survivorship Aggregate</h1>
                </div>
              </div>
            </Content>
          </Flex.Item>
          <Flex.Item span={12}>
            <Content>
              {isLoading ? (
                <Spinner />
              ) : hasLoaded ? (
                isRestricted ? (
                  <h2>
                    EID is restricted. Unable to display recomputed aggregate
                    details.
                  </h2>
                ) : isError ? (
                  <div>
                    <h2> There was an error recomputing the aggregate.</h2>
                    CorrelationId: {metaCorrelation}
                  </div>
                ) : (
                  <div>
                    <h2>Birth Date:</h2>
                    <pre>
                      {birthDate != ""
                        ? birthDate
                        : "No birth date found in aggregate."}
                    </pre>
                    <br />
                    <h2>Primary Residence:</h2>
                    <pre>
                      {primaryAddress != ""
                        ? primaryAddress
                        : "No primary residence found in aggregate."}
                    </pre>
                  </div>
                )
              ) : null}
            </Content>
          </Flex.Item>
        </Flex>
      </Container>
    </Layout>
  );
};

export default MockSurvivorship;
